import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as reducers from '../../reducers';
import { Store } from '@ngrx/store';

@Component({
	selector: 'product-filter-crumbs',
	template: `
	{{productParams$ | async | json}}
	`,
	styles: [`
	`]
})

export class ProductFilterCrumbsComponent implements OnInit {

	// @Input() productFilter;
	// @Input() productParams;
	@Output() clearFilter = new EventEmitter();

	productParams$;
	

	constructor(private store: Store<reducers.State>) {
	}

	ngOnInit() {

		this.productParams$ = this.store.select(reducers.getProductParams);
	}	
	
}